import { render, staticRenderFns } from "./ContactData.vue?vue&type=template&id=6db6e172"
import script from "./ContactData.vue?vue&type=script&lang=js"
export * from "./ContactData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Forms/ContactData.vue
// module id = 1512
// module chunks = 31